import type {SalesDynamicsDay} from '@ozon-ai/ozon/contracts';
import {CartesianGrid, Line, LineChart, XAxis, YAxis} from 'recharts';
import {
	ChartContainer,
	ChartLegend,
	ChartLegendContent,
	ChartTooltip,
	ChartTooltipContent,
	type ChartConfig,
} from '@/components/ui/chart.tsx';

const chartConfig = {
	sold: {label: 'Продано', color: 'var(--chart-1)'},
	delivered: {label: 'Доставлено', color: 'var(--chart-2)'},
	returned: {label: 'Возвращено', color: 'var(--chart-3)'},
	inStock: {label: 'В наличии', color: 'var(--chart-4)'},
} satisfies ChartConfig;

function formatDay(value: string): string {
	const [year, month, day] = value.split('-');
	if (!year || !month || !day) return value;
	return `${day}.${month}.${year}`;
}

export function SalesDynamicsChart({statistics}: {statistics: SalesDynamicsDay[]}) {
	return (
		<ChartContainer config={chartConfig} className="aspect-auto h-72 w-full">
			<LineChart data={statistics} margin={{left: 8, right: 8, top: 8}}>
				<CartesianGrid vertical={false}/>
				<XAxis
					dataKey="date"
					tickLine={false}
					axisLine={false}
					tickMargin={8}
					minTickGap={24}
					tickFormatter={(value: string) => formatDay(value).slice(0, 5)}
				/>
				<YAxis yAxisId="units" allowDecimals={false} tickLine={false} axisLine={false} width={32}/>
				<YAxis
					yAxisId="stock"
					orientation="right"
					allowDecimals={false}
					tickLine={false}
					axisLine={false}
					width={40}
				/>
				<ChartTooltip
					content={
						<ChartTooltipContent
							labelFormatter={(value) => formatDay(String(value))}
						/>
					}
				/>
				<ChartLegend content={<ChartLegendContent/>}/>
				<Line
					yAxisId="units"
					type="monotone"
					dataKey="sold"
					stroke="var(--color-sold)"
					strokeWidth={2}
					dot={false}
				/>
				<Line
					yAxisId="units"
					type="monotone"
					dataKey="delivered"
					stroke="var(--color-delivered)"
					strokeWidth={2}
					strokeDasharray="4 4"
					dot={false}
				/>
				<Line
					yAxisId="units"
					type="monotone"
					dataKey="returned"
					stroke="var(--color-returned)"
					strokeWidth={2}
					dot={false}
				/>
				<Line
					yAxisId="stock"
					type="monotone"
					dataKey="inStock"
					stroke="var(--color-inStock)"
					strokeWidth={2}
					dot={false}
					connectNulls={false}
				/>
			</LineChart>
		</ChartContainer>
	);
}
